import * as rnLocalStorage from './local-storage.service';

export default angular.module('rhino.components.localStorage', [

])
  .service(rnLocalStorage.name, rnLocalStorage.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/local-storage/local-storage.module.js